import React, { useState, useContext } from 'react';
import { connect } from 'react-redux';
import { KFLInput } from '@kamstrup/kamstrup-frontend-library';
import { ReduxState } from '../../interfaces';
import { useLifecycle } from '../../hooks/useLifecycle';
import * as Customers from '../../modules/customers';
import SidebarForm from './sidebarForm';
import { Groups } from '../../models';
import { resetScroll } from '../../modules/datatable';
import { LocaleCtx } from '../../contexts/locale.context';

interface StateProps {
  filterCriteria: Customers.FilterCriteria;
  isLoading: boolean;
}

type Props = StateProps & { id: string };

const CustomerSidebar: React.FC<Props> = (props) => {
  useLifecycle('CustomerSidebar');
  const [owner, setOwner] = useState(props.filterCriteria.owner);

  const handleSearch = () => {
    const criteria = { ...props.filterCriteria, owner };
    Customers.updateFilterCriteria(criteria, props.isLoading);
    resetScroll();
  };
  const handleClear = () => setOwner('');

  const { translate } = useContext(LocaleCtx);
  const customerNameTranslated = translate(Customers.msgCustomerName);
  return (
    <SidebarForm
      group={Groups.CUSTOMERS}
      fnSearch={handleSearch}
      fnClear={handleClear}
      isLoading={props.isLoading}
    >
      <KFLInput
        id="sb_customers_filter_id"
        label={customerNameTranslated}
        placeholder={customerNameTranslated}
        value={owner}
        onChange={setOwner}
      />
    </SidebarForm>
  );
};

const mapStateToProps = (state: ReduxState) => ({
  isLoading: state.customersState.table.isLoading,
  filterCriteria: state.customersState.filters,
});

export default connect(mapStateToProps)(CustomerSidebar);
